// SEO Schema Data for Snake Catchers Bangalore

const getBaseUrl = () => {
  if (typeof window !== 'undefined') return window.location.origin;
  return process.env.REACT_APP_BASE_URL || 'https://snakecatchersbangalore.com';
};

// Neighborhoods / localities actively served (East & Central Bangalore, 10km from 560043)
export const servedAreas = [
  'Babusapalya', 'Horamavu', 'Kalyan Nagar', 'Hennur', 'Ramamurthy Nagar',
  'Banaswadi', 'HRBR Layout', 'Kammanahalli', 'HBR Layout', 'Kacharakanahalli',
  'Hebbal', 'Lingarajapuram', 'Thanisandra', 'Nagawara', 'Kothanur',
  'Indiranagar', 'Ulsoor', 'CV Raman Nagar', 'KR Puram', 'Marathahalli',
  'Whitefield', 'Mahadevapura', 'Hoodi', 'Brookefield'
];

// Master keyword string — used across multiple schemas
const masterKeywords = [
  'snake catcher bangalore', 'snake catcher near me',
  'snake rescue bangalore', 'snake rescue near me',
  'snake removal bangalore', 'snake removal near me',
  'snake catcher number', 'snake rescue number',
  'snake in house', 'snake inside house', 'snake found in home',
  'snake emergency help', 'urgent snake removal', 'call snake catcher',
  'snake help near me', 'snake in room help',
  'snake in bathroom', 'snake in kitchen',
  'snake catcher horamavu', 'snake catcher babusapalya',
  'snake catcher kalyan nagar', 'snake catcher hennur',
  'snake catcher ramamurthy nagar',
  'snake rescue banaswadi', 'snake rescue hrbr layout',
  'snake rescue kammanahalli'
].join(', ');

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "EmergencyService"],
  "@id": `${getBaseUrl()}/#business`,
  "name": "Snake Catchers Bangalore",
  "alternateName": ["Snake Catcher Bangalore", "Snake Rescue Bangalore", "Bangalore Snake Catchers"],
  "image": [`${getBaseUrl()}/logo-512.png`],
  "logo": `${getBaseUrl()}/logo-512.png`,
  "description": "24/7 snake catcher near you in Bangalore. Expert emergency snake rescue & humane snake removal by certified handlers Alhan Nawaz and Mohan K.",
  "url": getBaseUrl(),
  "telephone": ["+91-8310755854", "+91-9845080903"],
  "priceRange": "Call for details",
  "keywords": masterKeywords,
  "currenciesAccepted": "INR",
  "paymentAccepted": "Cash, UPI",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Babusapalya",
    "addressLocality": "Bangalore",
    "addressRegion": "Karnataka",
    "postalCode": "560043",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "13.0156",
    "longitude": "77.6426"
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
    "opens": "00:00",
    "closes": "23:59"
  },
  "areaServed": servedAreas.map(name => ({
    "@type": "Place",
    "name": `${name}, Bangalore`
  })),
  "serviceArea": {
    "@type": "GeoCircle",
    "geoMidpoint": {
      "@type": "GeoCoordinates",
      "latitude": "13.0156",
      "longitude": "77.6426"
    },
    "geoRadius": "10000"
  },
  "employee": [
    { "@type": "Person", "name": "Alhan Nawaz", "jobTitle": "Snake Catcher & Rescuer", "telephone": "+91-8310755854" },
    { "@type": "Person", "name": "Mohan K", "jobTitle": "Snake Catcher & Rescuer", "telephone": "+91-9845080903" }
  ],
  "makesOffer": [
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Emergency Snake Rescue" } },
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Snake Removal from Home" } },
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Snake Awareness Workshops" } },
    { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Snake Safety Audits" } }
  ],
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+91-8310755854",
      "contactType": "Emergency",
      "areaServed": "IN-KA",
      "availableLanguage": ["English", "Hindi", "Kannada", "Urdu"]
    },
    {
      "@type": "ContactPoint",
      "telephone": "+91-9845080903",
      "contactType": "Emergency",
      "areaServed": "IN-KA",
      "availableLanguage": ["English", "Hindi", "Kannada", "Tamil"]
    }
  ]
};

export const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Emergency Snake Rescue and Removal",
  "name": "Snake Rescue & Removal Bangalore",
  "description": "24/7 emergency snake catcher & rescue service in Bangalore - safe and humane snake removal from homes, apartments, offices and institutions.",
  "provider": { "@id": `${getBaseUrl()}/#business` },
  "areaServed": { "@type": "City", "name": "Bangalore" },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": `${getBaseUrl()}/snake-rescue`,
    "servicePhone": [
      { "@type": "ContactPoint", "telephone": "+91-8310755854", "contactType": "Emergency" },
      { "@type": "ContactPoint", "telephone": "+91-9845080903", "contactType": "Emergency" }
    ]
  },
  "hoursAvailable": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
    "opens": "00:00",
    "closes": "23:59"
  }
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Snake Catchers Bangalore",
  "url": getBaseUrl(),
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${getBaseUrl()}/areas?q={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": `${getBaseUrl()}${item.path}`
  }))
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": { "@type": "Answer", "text": faq.answer }
  }))
});

// Home page FAQ — targets common search intents
export const homeFaqs = [
  {
    question: "Who is the best snake catcher in Bangalore?",
    answer: "Snake Catchers Bangalore, led by Alhan Nawaz (+91 8310755854) and Mohan K (+91 9845080903), is a trusted 24/7 emergency snake rescue service covering East and Central Bangalore including Horamavu, Babusapalya, Kalyan Nagar, Hennur, Ramamurthy Nagar, Banaswadi, HRBR Layout and Kammanahalli."
  },
  {
    question: "How do I find a snake catcher near me in Bangalore?",
    answer: "Call Alhan at +91 8310755854 or Mohan K at +91 9845080903. We operate 24/7 and typically reach any location within a 10 km radius from Babusapalya (560043) as fast as possible."
  },
  {
    question: "There is a snake in my house, what should I do?",
    answer: "Stay calm, keep children and pets away, do not corner or try to kill the snake, and close the door of the room if possible. Call Snake Catchers Bangalore immediately on +91 8310755854 or +91 9845080903 for urgent snake removal."
  },
  {
    question: "Do you rescue snakes from bathrooms and kitchens?",
    answer: "Yes. We regularly rescue snakes from bathrooms, kitchens, bedrooms, balconies, drains and gardens across Bangalore homes and apartments. Both venomous (cobra, krait, viper) and non-venomous (rat snake, python) species are handled safely."
  },
  {
    question: "Is there a 24/7 snake rescue number for Bangalore?",
    answer: "Yes - Snake Catchers Bangalore is available 24 hours a day, 7 days a week. Call +91 8310755854 (Alhan) or +91 9845080903 (Mohan K) for immediate emergency snake help."
  },
  {
    question: "Which areas of Bangalore do you cover?",
    answer: "We cover East & Central Bangalore including Horamavu, Babusapalya, Kalyan Nagar, Hennur, Ramamurthy Nagar, Banaswadi, HRBR Layout, Kammanahalli, HBR Layout, Hebbal, Indiranagar, Ulsoor, CV Raman Nagar, KR Puram, Marathahalli, Whitefield, Mahadevapura and surrounding localities."
  }
];

// Per-page keyword clusters
export const seoKeywords = {
  home: "snake catcher bangalore, snake catcher near me, snake rescue bangalore, snake rescue near me, snake removal bangalore, snake removal near me, snake catcher number, snake rescue number, snake in house, snake emergency help, urgent snake removal, call snake catcher, snake help near me, 24/7 snake catcher",

  snakeRescue: "snake rescue bangalore, snake rescue near me, snake removal bangalore, urgent snake removal, snake emergency help, snake in house, snake inside house, snake found in home, snake in room help, snake in bathroom, snake in kitchen, cobra rescue bangalore, python rescue bangalore, venomous snake removal",

  workshops: "snake awareness workshop bangalore, snake safety training bangalore, snake identification program, school snake awareness program, corporate snake safety training, wildlife education bangalore",

  safetyAudit: "snake safety audit bangalore, property snake assessment bangalore, apartment snake safety, corporate campus snake audit, snake prevention audit bangalore, residential snake proofing",

  areas: "snake catcher horamavu, snake catcher babusapalya, snake catcher kalyan nagar, snake catcher hennur, snake catcher ramamurthy nagar, snake rescue banaswadi, snake rescue hrbr layout, snake rescue kammanahalli, snake catcher hebbal, snake rescue whitefield, snake catcher marathahalli, snake rescue indiranagar, snake catcher kr puram, snake catcher near me bangalore",

  contact: "snake catcher number bangalore, snake rescue number, contact snake catcher bangalore, emergency snake rescue number, snake removal contact, call snake catcher"
};
